import { render, staticRenderFns } from "./Liquidacao.vue?vue&type=template&id=4874dad1&"
import script from "./Liquidacao.vue?vue&type=script&lang=js&"
export * from "./Liquidacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports